import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
var schema = defineObject('eventListingSection', {
    enableTaxonomyFilter: {
        title: 'Enable taxonomy filter',
        type: 'boolean'
    }
});
var validator = z.object({
    enableTaxonomyFilter: z.boolean()
}).partial();
schema.eventListingSection;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=eventListingSection.js.map